import {
  DocumentType,
  ListDocumentsResponse,
} from 'store/invoices/invoices.types'

export const documentFullName = (documentType: string): string => {
  switch (documentType as DocumentType) {
    case 'LC':
      return 'Load Confirmation'
    case 'INVOICE':
      return 'Invoice'
    case 'WAYBILL':
      return 'Waybill'
    case 'REMITTANCE':
      return 'Remittance'
    case 'PAYMENT_RECEIPT':
      return 'Cheque / EFT / Etransfer'
    case 'OTHER':
      return 'Other'
    case 'BOL':
      return 'BOL'
    case 'POD':
      return 'POD'
    default:
      return documentType
  }
}

const BATCH_EMAIL_DOCUMENT_TYPES = [
  'INVOICE',
  'WAYBILL',
  'BOL',
  'POD',
] as const

export const getS3UrlsForAttachments = (
  documents: ListDocumentsResponse | undefined
): string[] => {
  const attachments: string[] = []

  documents?.INVOICE?.map((file) => attachments.push(file.s3Path))
  documents?.WAYBILL?.map((file) => attachments.push(file.s3Path))
  documents?.LC?.map((file) => attachments.push(file.s3Path))
  documents?.BOL?.map((file) => attachments.push(file.s3Path))
  documents?.POD?.map((file) => attachments.push(file.s3Path))
  documents?.REMITTANCE?.map((file) => attachments.push(file.s3Path))
  documents?.PAYMENT_RECEIPT?.map((file) => attachments.push(file.s3Path))
  documents?.OTHER?.map((file) => attachments.push(file.s3Path))

  return attachments
}

/** Invoice, waybill, BOL, and POD for each order in a batch email (merged attachment). */
export const getBatchOrderDocumentS3Urls = (
  documents: ListDocumentsResponse | undefined,
  includeWaybill = true
): string[] => {
  const attachments: string[] = []
  const types = includeWaybill
    ? BATCH_EMAIL_DOCUMENT_TYPES
    : BATCH_EMAIL_DOCUMENT_TYPES.filter((type) => type !== 'WAYBILL')

  for (const docType of types) {
    documents?.[docType]?.forEach((file) => attachments.push(file.s3Path))
  }

  return attachments
}
